<script setup lang="ts">
defineProps({
  showList: { type: Boolean }
})
const emits = defineEmits(['chooseMusic'])
const userStore = useUserStore()
const { musicInfo } = storeToRefs(userStore)
const { formatTime } = useOSSUploader()

const current = ref(0)
const chooseMusic = (index: number) => {
  current.value = index
  // play()
  emits('chooseMusic', index)
}
</script>

<template>
  <div
    :class="`${
      showList && musicInfo.musicList?.length ? 'max-h-83.5 h-max py-2' : 'max-h-0 b-none'
    } df-b b transition-all w-full duration-200 overflow-auto bg-[#303335] bg-op-60 backdrop-blur-[50px] rounded-2.5 mb-1.5 md:w-94 md:max-w-94 md:absolute md:bottom-16.5 md:right-12`"
  >
    <div
      v-for="(item, index) in musicInfo.musicList"
      :key="item?.url + index"
      class="w-full h-12 px-3 flex items-center text-xs cursor-pointer hover:text-white hover:bg-white hover:bg-op-10"
      @click="chooseMusic(index)"
    >
      <div class="w-4 h-4 mr-3">
        <div
          v-if="index === current"
          i-carbon:volume-up-filled
          class="w-4 h-4"
          :class="index === current ? 'icon-bg-right' : 'icon-white'"
        />
        <div v-else class="text-center text-sm text-white text-op-60">
          {{ index + 1 }}
        </div>
      </div>
      <div class="w-70">
        <div
          :class="`max-w-full w-max truncate text-base ${index === current ? 'font-bg md:text-brandYellow font-semibold' : 'text-white'}`"
        >
          {{ item?.name }}
        </div>
        <div
          :class="`max-w-full truncate text-sm ${index === current ? 'text-white' : 'text-white text-op-40'}`"
        >
          {{ item?.userName }}
        </div>
      </div>
      <div
        :class="`w-max text-sm ${index === current ? 'font-bg md:text-brandYellow' : 'text-white text-op-40'}`"
      >
        {{ formatTime(item?.duration || 0) }}
      </div>
    </div>
  </div>
</template>
